import React from 'react';
import { motion } from 'framer-motion';
import SubscriptionGate from '../components/SubscriptionGate';

function AskAI() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#151C2A] via-[#0C1017] to-[#080B10]" />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 0.4, scale: 1 }}
          transition={{ duration: 0.85, ease: 'easeOut' }}
          className="absolute left-20 top-16 h-52 w-52 rounded-full bg-primary/30 blur-3xl"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 0.4, scale: 1 }}
          transition={{ duration: 1.05, ease: 'easeOut', delay: 0.15 }}
          className="absolute bottom-10 right-24 h-60 w-60 rounded-full bg-violet-500/30 blur-3xl"
        />
      </div>
      <div className="relative mx-auto flex max-w-5xl flex-col gap-10 px-6 py-16 text-white">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">Assist</p>
          <h1 className="text-4xl font-semibold">Ask AI</h1>
          <p className="text-sm text-white/60">
            Unlock conversational diagnostics, recommended actions, and contextual answers for your equipment by
            upgrading to the full AI suite.
          </p>
        </div>
        <SubscriptionGate
          title="Full Subscription Required"
          description="Ask AI helps your team troubleshoot faster with contextual knowledge of every asset. Upgrade to start the conversation."
          cta="Explore Plans"
        />
      </div>
    </div>
  );
}

export default AskAI;
